import { SSIUplineResponse } from "../../../services/SSIUpline/ssiUplineAPI.types";
import { InWindowWrapper, Row } from "./InWindowWrapper/InWindowWrapper";
import "./InWindowSections.scss";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/ssiUplineReport";
import { useEffect, useRef } from "react";
import { ERROR_TYPE, ErrorPage, IconType } from "../../ErrorPage/ErrorPage";
import { track } from "../../../common/util/tealium";

interface Props {
  ssiUplineData: SSIUplineResponse;
  isLoading: boolean;
  selectedAboNumber: string;
  viewType: "mobile" | "desktop";
}

export const InWindowSections = ({ ssiUplineData, isLoading, selectedAboNumber, viewType }: Props) => {
  const { t } = useTranslation(["ssiUplineReport"]);
  const scrollRef = useRef<HTMLDivElement>(null);
  const confidentialUser = t("common:confidentialUser", defaultContent["confidentialUser"]).toString();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedAboNumber]);

  const inPaymentMonth: Row[] = ssiUplineData.InWindow.InPaymentMonth.map((row): Row => {
    return {
      AboName: row.AboName && row.AboName.length > 0 ? row.AboName : confidentialUser,
      AboNum: row.Abo,
      Aff: row.Aff,
      Requirements: row.Requirements,
      EligibilityWindow: row.EligibilityWindow,
      SponsorName: row.SponsorName && row.SponsorName.length > 0 ? row.SponsorName : confidentialUser,
      SponsorNum: row.SponsorABO,
      IsHighlighted: row.Abo === selectedAboNumber,
      scrollRef: row.Abo === selectedAboNumber ? true : false,
    };
  });

  const inSSIProgram: Row[] = ssiUplineData.InWindow.InSSIProgram.map((row): Row => {
    return {
      AboName: row.AboName && row.AboName.length > 0 ? row.AboName : confidentialUser,
      AboNum: row.Abo,
      Aff: row.Aff,
      Requirements: row.Requirements,
      EligibilityWindow: row.EligibilityWindow,
      SponsorName: row.SponsorName && row.SponsorName.length > 0 ? row.SponsorName : confidentialUser,
      SponsorNum: row.SponsorABO,
      IsHighlighted: row.Abo === selectedAboNumber,
      scrollRef: row.Abo === selectedAboNumber ? true : false,
    };
  });

  if (inPaymentMonth.length === 0 && inSSIProgram.length === 0 && !isLoading) {
    return (
      <div className="InWindowSections__error">
        <ErrorPage
          errorType={ERROR_TYPE.NO_DOWNLINES}
          iconType={IconType.SearchCriteria}
          tealiumTrackFunction={() => track("view", "", "in-window_tab", "ssi_upline_report", "no_downlines", "")}
        />
      </div>
    );
  }

  return (
    <div className="InWindowSections">
      <>
        {((!isLoading && inPaymentMonth.length !== 0) || isLoading) && (
          <div className="InWindowSections__sectionTitle">
            {`${t("inSSIProgram.inPaymentMonth", defaultContent.inSSIProgram.inPaymentMonth)}`}
          </div>
        )}
        <div className="InWindowSections__section">
          <InWindowWrapper
            rows={inPaymentMonth}
            isLoading={isLoading}
            selectedAboNumber={selectedAboNumber}
            viewType={viewType}
          />
        </div>
        {((!isLoading && inSSIProgram.length !== 0) || isLoading) && (
          <div className="InWindowSections__sectionTitle">{`${t(
            "inSSIProgram.inSSIProgram",
            defaultContent.inSSIProgram.inSSIProgram,
          )}`}</div>
        )}
        <div className="InWindowSections__section">
          <InWindowWrapper
            rows={inSSIProgram}
            isLoading={isLoading}
            selectedAboNumber={selectedAboNumber}
            viewType={viewType}
          />
        </div>
      </>
    </div>
  );
};
